/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Hls_HelpInputs */

const en_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the URL of your HLS manifest file`)
};

const fr_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez l'URL de votre fichier manifeste HLS`)
};

const de_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie die URL Ihrer HLS-Manifestdatei ein.`)
};

const it_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci l'URL del tuo file manifest HLS`)
};

const ru_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите URL-адрес вашего файла манифеста HLS.`)
};

const es_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese la URL de su archivo de manifiesto HLS`)
};

const zh_cn2_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的 HLS 清单文件的 URL`)
};

const ja_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLSマニフェストファイルのURLを入力してください`)
};

const hi_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी HLS मैनिफेस्ट फ़ाइल का URL दर्ज करें`)
};

const pt_pt2_media_import_hls_help = /** @type {(inputs: Media_Import_Hls_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira a URL do seu arquivo de manifesto HLS.`)
};

/**
* | output |
* | --- |
* | "Enter the URL of your HLS manifest file" |
*
* @param {Media_Import_Hls_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_hls_help = /** @type {((inputs?: Media_Import_Hls_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Hls_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_hls_help(inputs)
	if (locale === "de") return de_media_import_hls_help(inputs)
	if (locale === "it") return it_media_import_hls_help(inputs)
	if (locale === "ru") return ru_media_import_hls_help(inputs)
	if (locale === "es") return es_media_import_hls_help(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_hls_help(inputs)
	if (locale === "ja") return ja_media_import_hls_help(inputs)
	if (locale === "hi") return hi_media_import_hls_help(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_hls_help(inputs)
	return en_media_import_hls_help(inputs)
});